<template>
    <div class="row ms-3 me-3 pb-3 pt-3" >
        <div class="col-5 align-self-center">
            <div class="fs-28 text-uppercase fw-bold color-secondary">{{this.cartItem.name}}</div>
        </div>
        <div class="col-4 align-self-center text-center">
            <div v-if="typeof this.place !== 'undefined'">
                <div class="big_number">
                    Section <span class="black color-secondary">{{ this.place['section'] }}</span>,
                    Rangée <span class="black color-secondary">{{ this.place['row'] }}</span>,
                    Siège <span class="black color-secondary">{{ this.place['seat'] }}</span>
                </div>
            </div>
            <div v-if="typeof this.place == 'undefined' && this.selected" class="d-flex align-items-center">
                <div class="pe-4"><i class="fas fa-long-arrow-down"></i></div>
                <div>Sélectionnez un siège dans le plan ci-dessous</div>
                <div class="ps-4"><i class="fas fa-long-arrow-down"></i></div>
            </div>
        </div>
        <div class="col-3 align-self-center text-center">
            <div @click="valid_selected($event)" :seating_chart_id="this.idx" class="custom_radio flex-shrink-0" :selected="this.selected"
            v-bind:class="typeof this.place !== 'undefined'?'place_is_selected_radio_box':''"
            ></div>
        </div>
    </div>
</template>

<script>
export default {
    name: "SeatingItem",
    emits: ['test'],
    data() {
        return {
            event_id: null,
            selected: false,
            seat_info: '',
            time_left: null,
            second_left: null,
            time_converted: null,
            time_interval: null,
        }
    },
    created() {
        this.init();
    },
    watch: {

        /*
        place(value){
            this.change_time(value.time_end);
        },
        */

    },

    methods: {
        init() {
            let t_cart_items_infos = {};
            t_cart_items_infos["m_uid"] = this.idx;
            t_cart_items_infos["m_product_id"] = this.cartItem.idx;
            t_cart_items_infos["m_quantity"] = 1;




            t_cart_items_infos["m_concretized_availability_uids"] = this.cartItem.features.FEATURE_AVAILABILITY_POOLS_CONCRETIZED_AVAILABILITY_UIDS;

            let databaseUID = null;
            if (typeof this.place !== 'undefined') {
                databaseUID = this.place['databaseUID'];

               //this.change_time(this.place['time_end']);
            }

            t_cart_items_infos["m_seating_chart_element_uid"] = databaseUID;

            if(this.index == 0)
            {
                this.selected = true;
                this.$parent.seat_to_place.push(this.index);
            }

            this.$parent.updateCartItem(t_cart_items_infos);

            if(this.index === (this.nb - 1))
            {
                this.$parent.if_seating_item_is_loaded = true;
            }


        },
        valid_selected(event)
        {
            let nb = 0;
            //console.log(this.$parent.$refs);

            let childs  = this.$parent.$refs;
            let keys  = Object.keys(childs);

            for(let i = 0 ; i<keys.length;++i)
            {
                if(childs[keys[i]][0].selected == true && this.idx != childs[keys[i]][0].idx)
                {
                    nb++;
                }
            }


            if(nb > 0) {
                if (this.selected === true) {
                    this.selected = false;
                    this.$parent.updateSeatToPlace('remove', this.index);
                } else {
                    this.selected = true;
                    this.$parent.updateSeatToPlace('add', this.index);
                }
            }
        },
        /*
        reduce_time()
        {
            this.time_left -= 1000;
        },
        get_time_left_converted()
        {
            return this.time_left;
        },
        */
        /*
        change_time(time)
        {
            this.time_left = time;
            let second_left = (this.time_left - new Date().getTime()) / 1000;
            second_left = Math.floor(second_left);

            this.second_left = second_left;

            if(this.time_interval !== null)
            {
                clearInterval(this.time_interval);
                this.time_interval = null;
            }

            this.time_interval = setInterval(() => {
                this.interval_time();
            }, 1000);
        },
         */
        /*
        interval_time()
        {
            this.second_left--;

            if(this.second_left <= 0)
            {
                this.second_left = 0;
                clearInterval(this.time_interval);

            }

            let second_left = this.second_left;
            let min = 0;
            let sec = 0;
            min = Math.floor(this.second_left / 60);
            sec = this.second_left % 60;
            if(sec < 10)
            {
                sec = '0'+sec;
            }

            this.time_converted = min + ":"+sec;
        },
         */

    },




    props: {
        cartItem: Object,
        idx: String,
        index: Number,
        nb: Number,
        place: Array,
    }
}
</script>

<style scoped>

</style>
